import React, { useContext } from 'react';

import { MDText } from 'i18n-react';

import { Button } from '@motorway/mw-highway-code';

import { PAYMENT_PAGE_EVENTS } from 'Utilities/analytics/analyticsPaymentPage';
import { formatPrice } from 'Utilities/formatPrice';
import useUrlVRM from 'Utilities/hooks/useUrlVRM';

import { FiguresBox } from '../components/FiguresBox/FiguresBox';
import FinanceApplicable from '../components/FiguresBox/FinanceApplicable/FinanceApplicable';
import LocalTexts from '../Payments.text.json';
import { PaymentViewProps } from '../Payments.types';
import { PaymentContext } from '../PaymentsContext';

import styles from './PaymentEnter.scss';

const LocalT = new MDText(LocalTexts.payments.enterView);

const PaymentEnter = ({ actions }: PaymentViewProps) => {
  const { vrm } = useUrlVRM({ optimisticReturn: true });
  const { paymentState: { accountNumber, dealerName, financingAmount, sellerAmount } } = useContext(PaymentContext);

  return (
    <div className={styles.paymentEnterWrapper}>
      <FiguresBox
        buttons={
          <>
            <Button
              fullWidth
              icon="chevron"
              label={`${LocalT.translate('buttons.accept')}`}
              onClick={() => {
                actions.showAcceptView();
                PAYMENT_PAGE_EVENTS.VEHICLE_PAYMENT_CONTINUE_BUTTON_CLICKED({
                  buttonLabel: `${LocalT.translate('buttons.accept')}`,
                  vrm,
                });
              }}
            />
            <Button
              fullWidth
              label={`${LocalT.translate('buttons.decline')}`}
              onClick={() => {
                actions.showDeclineView();
                PAYMENT_PAGE_EVENTS.VEHICLE_PAYMENT_CONTACT_BUTTON_CLICKED({
                  buttonLabel: `${LocalT.translate('buttons.decline')}`,
                  vrm,
                });
              }}
              variant="secondary"
            />
          </>
        }
        content={
          <>
            {financingAmount ? (
              <FinanceApplicable showIncorrectFinanceButton title={`${LocalT.translate('financeApplicableTitle')}`} />
            ) : (
              <p>
                {LocalT.translate('text1')}
                <span className={styles.amount}>{formatPrice(sellerAmount)}</span>
                {LocalT.translate('text2', { accountNumber })}
              </p>
            )}
          </>
        }
        title={`${LocalT.translate('title', { dealer: dealerName })}`}
      />
    </div>
  );
};

export { PaymentEnter };
